import { Link } from 'react-router-dom'
import Icon from '../components/Icon.jsx'

export default function Shipping() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>Shipping & Returns</span></nav>
      <header className="page-head">
        <h1>Shipping & returns</h1>
        <p>Glass-safe local delivery within 50 km of Ravenhall (Victoria), or free pickup from our warehouse.</p>
      </header>

      <section className="prose">
        <h2><Icon name="truck" size={20} /> Delivery</h2>
        <table className="info-table">
          <thead>
            <tr><th>Zone</th><th>Transit after dispatch</th></tr>
          </thead>
          <tbody>
            <tr><td>Warehouse pickup — Ravenhall VIC</td><td>Free · ready in 1–2 business days</td></tr>
            <tr><td>Local delivery — within 50 km of Ravenhall (VIC only)</td><td>Flat rate · 1–3 business days</td></tr>
          </tbody>
        </table>
        <p>
          Delivery is a flat rate shown at checkout before you pay, and covers addresses within 50 km of
          our Ravenhall warehouse. If your address is outside the zone, we'll contact you before processing
          the order. Large glass orders travel glass-safe — we'll confirm delivery arrangements for
          oversized orders.
        </p>

        <h2><Icon name="clock" size={20} /> Processing times</h2>
        <ul className="prose-list">
          <li><Icon name="check" size={16} /> Stocked hardware, accessories and tools: 1–2 business days</li>
          <li><Icon name="check" size={16} /> Stocked glass panels: 2–3 business days</li>
          <li><Icon name="check" size={16} /> Custom / made-to-order glass: confirmed at time of order, full payment upfront</li>
        </ul>
        <p>Orders are processed once payment is verified. Orders after 2:00pm AEST or on weekends are processed the next business day.</p>

        <h2><Icon name="box" size={20} /> Packaging</h2>
        <p>
          All glass is packed with foam padding, cardboard crating and protective wrap, and inspected before
          dispatch. Please check your delivery on arrival and report any transit damage within 48 hours with photos.
        </p>

        <h2><Icon name="shield" size={20} /> Warranty & returns</h2>
        <ul className="prose-list">
          <li><Icon name="check" size={16} /> Hardware: 2-year warranty against manufacturing defects</li>
          <li><Icon name="check" size={16} /> Glass: inspected before dispatch; size tolerance up to 3mm</li>
          <li><Icon name="check" size={16} /> 30-day returns on eligible stocked items (unused, in original packaging)</li>
          <li><Icon name="check" size={16} /> Custom-made glass and Master Range items can't be returned unless faulty</li>
        </ul>
        <p>To start a return, <Link to="/contact">contact us</Link> with your order reference.</p>
      </section>
    </main>
  )
}
